import { render, staticRenderFns } from "./AddLongTalkgroup.vue?vue&type=template&id=02b7c384&scoped=true"
import script from "./AddLongTalkgroup.vue?vue&type=script&lang=js"
export * from "./AddLongTalkgroup.vue?vue&type=script&lang=js"
import style0 from "./AddLongTalkgroup.vue?vue&type=style&index=0&id=02b7c384&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02b7c384",
  null
  
)

export default component.exports